import { AutoheldenLogo } from "@App/Components/atoms/whitelabel/logos/AutoheldenLogo";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the Autohelden whitelabel.
 * Extends the default configuration with specific settings for Autohelden.
 */
export const config: Partial<Config> = {
  slug: "autohelden",
  navbar: {
    logos: {
      left: {
        component: <AutoheldenLogo />,
      },
      right: {
        component: <RepareoLogo />,
      },
    },
    backToPartnerButton: {
      url: "https://fahrzeuge-autohelden.de/",
    },
  },
  reviews: {
    show: true,
  },
};

export default config;
